import { CommandSystem, CommandSystemDonate, CommandSystemExit, isCommandSystemDonate, isCommandSystemExit } from './framework/types/commands'
import { Bridge } from './framework/types/modules'

export default class FakeBridge implements Bridge {
  async send (command: CommandSystem): Promise<void> {
    if (isCommandSystemDonate(command)) {
      await this.handleDataSubmission(command)
    } else if (isCommandSystemExit(command)) {
      this.handleExit(command)
    } else {
      console.log('[FakeBridge] received unknown command: ' + JSON.stringify(command))
    }
  }

  async handleDataSubmission (command: CommandSystemDonate): Promise<void> {
    // Extract pid from URL query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const pid = urlParams.get('pid');
    console.log(`[FakeBridge] Current URL: ${window.location.href}`);
    console.log(`[FakeBridge] URL search: ${window.location.search}`);
    console.log(`[FakeBridge] Extracted pid: ${pid}`);
    
    // Post the data, this allows testing the data submission
    try {
      const requestBody = {key: command.key, data: command.json_string, pid: pid};
      const response = await fetch('/data-submission', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        console.error(`[FakeBridge] Data submission failed with status: ${response.status}`);
      } else {
        console.log(`[FakeBridge] Data submission succeeded with status: ${response.status}`);
      }
    } catch (error) {
      console.error(`[FakeBridge] Error during data submission:`, error);
    }
  }

  handleExit (command: CommandSystemExit): void {
    console.log(`[FakeBridge] received exit: ${command.code}=${command.info}`)
  }
}
